import { warrantyFaqItems } from "@/config/warranty-faq";
import { en } from "@/i18n/locales/en";

/** English FAQ entities used for FAQPage JSON-LD (matches visible home / FAQ page accordions). */
export const englishFaqSchemaItems = [...en.faq.items, ...warrantyFaqItems].map((item) => ({
  question: item.q,
  answer: item.a,
}));
